import type { MonthlyTask, MonthlyWeek } from "../data/monthly";

interface MonthlyReminderBannerProps {
  tasks: MonthlyTask[];
  weekData: MonthlyWeek | null;
  onDismiss: () => void;
  onViewMonthly: () => void;
}

/** Green banner shown on the daily timeline when there's a monthly task for today. */
export function MonthlyReminderBanner({ tasks, weekData, onDismiss, onViewMonthly }: MonthlyReminderBannerProps) {
  return (
    <div
      style={{
        background: "linear-gradient(135deg,#d0e1c9,#e8f0e4)",
        border: "1.5px solid #8dad82",
        borderRadius: 16,
        padding: "14px 16px",
        marginBottom: 12,
        position: "relative",
        boxShadow: "0 3px 14px rgba(109,156,107,0.2)",
      }}
    >
      <button
        onClick={onDismiss}
        style={{
          position: "absolute",
          top: 10,
          right: 12,
          background: "none",
          border: "none",
          fontSize: 18,
          cursor: "pointer",
          color: "#6a9c6b",
          lineHeight: 1,
          padding: 0,
        }}
      >
        ×
      </button>
      <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 8 }}>
        <span style={{ fontSize: 18 }}>📅</span>
        <div>
          <div style={{ fontSize: 12, fontWeight: 700, color: "#3a5c38" }}>Monthly Reminder</div>
          <div style={{ fontSize: 10, color: "#6a9c6b", fontStyle: "italic" }}>
            {weekData?.week} — today's the day
          </div>
        </div>
      </div>
      {tasks.map((task) => (
        <div key={task.id} style={{ display: "flex", alignItems: "flex-start", gap: 7, marginBottom: 5 }}>
          <span style={{ color: "#6a9c6b", fontSize: 11, marginTop: 2 }}>•</span>
          <div>
            <div style={{ fontSize: 12, color: "#3a5c38", lineHeight: 1.4, fontWeight: 600 }}>{task.label}</div>
            <div style={{ fontSize: 9, color: "#6a9c6b", marginTop: 1 }}>
              📌 {task.slot} · ⏱ {task.duration}
            </div>
          </div>
        </div>
      ))}
      <div
        onClick={onViewMonthly}
        style={{
          marginTop: 8,
          fontSize: 10,
          color: "#3a5c38",
          fontWeight: 700,
          cursor: "pointer",
          textDecoration: "underline",
        }}
      >
        View full monthly plan →
      </div>
    </div>
  );
}
